module.exports = __webpack_public_path__ + "img/eco3.b453e631.png";